import i18n from "i18next";


export const ACTIVATE_STATUS = [
    { label: i18n.t('constants.status.active'), value: 'A' },
    { label: i18n.t('constants.status.inactive'), value: 'I' },
];
export const NBDEM = [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }, { label: '4', value: 4 }, { label: '5', value: 5 }];
export const CIVITLITIES = [
    { label: i18n.t('constants.civilities.mister'), value: 'M' },
    { label: i18n.t('constants.civilities.mistress'), value: 'F' },
    { label: i18n.t('constants.civilities.lady'), value: 'A' },
];

export const DICTIONARIES = [
    { label: i18n.t('constants.dictionary.chapter'), code: 'C' },
    { label: i18n.t('constants.dictionary.exam'), code: 'X' },
    { label: i18n.t('constants.dictionary.analyse'), code: 'E' },
];

export const DICTIONARY_VISIBILITY = [
    { label: i18n.t('constants.dictionary_visibility.none'), value: 3 },
    { label: i18n.t('constants.dictionary_visibility.none_with_cr'), value: 4 },
    { label: i18n.t('constants.dictionary_visibility.prescriber'), value: 2 },
    { label: i18n.t('constants.dictionary_visibility.all'), value: 1 },
];

// export const CONSULTATION_STATUS = [
//     { label: 'Toutes les demandes', value: '' },
//     { label: 'Demandes urgentes et non lues', value: '' },
//     { label: 'Demandes urgentes', value: '' },
//     { label: 'Demandes non lues', value: '' },
//     { label: 'Demandes sans aucun résultat', value: '' },
//     { label: 'Prélèvements du jour', value: '' },
// ];

export const DEFAULT_DELTA_DAYS = [
    { label: i18n.t('constants.delta_days.lastday'), value: '1' },
    { label: i18n.t('constants.delta_days.last2days'), value: '2' },
    { label: i18n.t('constants.delta_days.last3days'), value: '3' },
    { label: i18n.t('constants.delta_days.last4days'), value: '4' },
    { label: i18n.t('constants.delta_days.last5days'), value: '5' },
    { label: i18n.t('constants.delta_days.last6days'), value: '6' },
    { label: i18n.t('constants.delta_days.last7days'), value: '7' },
    { label: i18n.t('constants.delta_days.last10days'), value: '10' },
    { label: i18n.t('constants.delta_days.last15days'), value: '15' },
    { label: i18n.t('constants.delta_days.last20days'), value: '20' },
    { label: i18n.t('constants.delta_days.last30days'), value: '30' }

];

// export const RESULT_CLASSEMENT = [
//     { label: 'Date de demande', value: 'D' },
//     { label: 'Date de prélèvement', value: 'P' },
// ];
export const YES_OR_NO = [
    { label: i18n.t('constants.yes_or_no.yes'), value: 'O' },
    { label: i18n.t('constants.yes_or_no.no'), value: 'N' },
];

export const FOLDER_TYPES = [
    { value: "pdf", label: i18n.t('constants.folder_types.pdf') },
    { value: "zip ", label: i18n.t('constants.folder_types.zip') },
    { value: "hprim", label: i18n.t('constants.folder_types.hprim') },

];
export const PRESCRIPTION_ACTOR = [
    { label: i18n.t('constants.prescription_actor.none'), value: 3 },
    { label: i18n.t('constants.prescription_actor.prescriber'), value: 2 },
    { label: i18n.t('constants.prescription_actor.non_exclusive_prescriber'), value: 4 },
    { label: i18n.t('constants.prescription_actor.all'), value: 1 }
];

// Pas exploité
export const DOWNLOAD = [
    { label: 'Récupérer tous les dossiers du jour', value: 'ALLDAY' },
    { label: 'Récupérer tous les dossiers depuis le dernier téléchargement automatique', value: 'ALL' },
    { label: 'Rechercher un dossier particulier', value: 'PC' },
    { label: 'Récupérer le programme de téléchargement automatique sur PC-Win98', value: 'PCWin98' },
];

export const ACTIONS = {
    LOADCR: 'LOADCR',
    UPDATEDEMANDREAD: 'UPDATEDEMANDREAD',
    LOGOUT: 'LOGOUT',
    SAVEACCOUNT: 'SAVEACCOUNT',
    ADDDELEG: 'ADDDELEG',
    SAVEDELEG: 'SAVEDELEG',
    DELETEDELEG: 'DELETEDELEG',
    SAVEPARAM: 'SAVEPARAM',
    SEARCHACTOR: 'SEARCHACTOR',
    LOADACTOR: 'LOADACTOR',
    GETUSERSFORACTOR: 'GETUSERSFORACTOR',
    ALLACTORTYPE: 'ALLACTORTYPE',
    ALLPROFILE: 'ALLPROFILE',
    ALLFONCTIONS: 'ALLFONCTIONS',
    ALLACTIONS: 'ALLACTIONS',
    ALLACTORS: 'ALLACTORS',
    ALLLABOS: 'ALLLABOS',
    LOADPARAM: 'LOADPARAM',
    LOADEXAMS: 'LOADEXAMS',
    CONSULTDEMANDE: 'CONSULTDEMANDE',
    EXISTSDEMANDES: 'EXISTSDEMANDES',
    DELETEDEMAND: "DELETEDEMAND",
    LOADDEMANDINFOS: "LOADDEMANDINFOS",
    SEARCHDELEG: 'SEARCHDELEG',
    LOADDELEG: 'LOADDELEG',
    LOADUSERS: 'LOADUSERS',
    LOADRESULTSCREEN: 'LOADRESULTSCREEN',
    LOADRESULTSCREENATDEMAND: "LOADRESULTSCREENATDEMAND",
    LOADFUSION: 'LOADFUSION',
    SAVEFUSION: 'SAVEFUSION',
    SEARCHFILTER: 'SEARCHFILTER',
    LOADFILTER: 'LOADFILTER',
    UPDATEFILTER: 'UPDATEFILTER',
    ADDFILTER: 'ADDFILTER',
    DELETEFILTER: 'DELETEFILTER',
    LOADMESSAGE: 'LOADMESSAGE',
    SEARCHPATIENT: 'SEARCHPATIENT',
    LOADDEMANDSFORPATIENT: "LOADDEMANDSFORPATIENT",
    LOADGRAPH: "LOADGRAPH",
    SEARCHPROFILE: 'SEARCHPROFILE',
    LOADPROFILE: 'LOADPROFILE',
    SEARCHUSER: 'SEARCHUSER',
    LOADUSER: 'LOADUSER',
    LOADACCOUNT: 'LOADACCOUNT',
    LOADUSERPREF: 'LOADUSERPREF',
    UPDATEUSERPREF: 'UPDATEUSERPREF',
    UPDATEACTOR: 'UPDATEACTOR',
    ADDACTOR: 'ADDACTOR',
    DELETEACTOR: 'DELETEACTOR',
    LOADPATIENT: 'LOADPATIENT',
    UPDATEPROFILE: 'UPDATEPROFILE',
    DELETEPROFILE: 'DELETEPROFILE',
    DELETEUSER: 'DELETEUSER',
    UPDATEUSER: 'UPDATEUSER',
    ADDUSER: 'ADDUSER',
    ADDPROFILE: 'ADDPROFILE',
    ISLOGINVALID: 'ISLOGINVALID',
    ISACTORCODEVALID: 'ISACTORCODEVALID',
    ISPROFILECODEVALID: 'ISPROFILECODEVALID',
    ISPASSWORDVALID: 'ISPASSWORDVALID',
    ISGROUPVALID: 'ISGROUPVALID',
    SEARCHDICOCHAPTERS: 'SEARCHDICOCHAPTERS',
    SEARCHDICOEXAMS: 'SEARCHDICOEXAMS',
    SEARCHDICOANALYSIS: 'SEARCHDICOANALYSIS',
    LOADCHAPTERINFOS: 'LOADCHAPTERINFOS',
    LOADEXAMINFOS: 'LOADEXAMINFOS',
    LOADANALYSISINFOS: 'LOADANALYSISINFOS',
    SAVECHAPTERINFOS: 'SAVECHAPTERINFOS',
    SAVEEXAMINFOS: 'SAVEEXAMINFOS',
    SAVEANALYSISINFOS: 'SAVEANALYSISINFOS',
    IVRSVERSION: 'IVRSVERSION',
    ALLACTORSFORUSER: 'ALLACTORSFORUSER',
    INFOSACTORSFORUSER: 'INFOSACTORSFORUSER',
    ALLFILTERSFORUSER: 'ALLFILTERSFORUSER',
    ALLUSERACTORS: 'ALLUSERACTORS'
};

export const INS_MAX_LENGTH = 15;

export const iconNamesExam = {
    "N": "",
    "": "",
    null: "",
    "A": "anormal",
    "AA": "anormal-extra",
    "L": "arrow-down",
    "H": "arrow-up",
    "<": "arrow-left",
    ">": "arrow-right",
    "LL": "arrow-cross-down",
    "HH": "arrow-cross-up",
    "non-definible": "",
    "B": "arrow-up-45",
    "W": "arrow-down-45",
    "U": "arrow-double-45-up",
    "D": "arrow-double-45-down"
};

// pas besoin de traduction, styleclass
export const statusExamStyle = {
    "N": "normal",
    "canceled": "canceled",
    "A": "anormal",
    "AA": "tres-anormal",
    "L": "inf-normal",
    "H": "sup-normal",
    "<": "inf-minimale",
    ">": "sup-minimale",
    "LL": "inf-panique",
    "HH": "sup-panique",
    "nonDefinible": "non-definible",
    "B": "amelioration",
    "W": "degradation",
    "U": "forte-augmentation",
    "D": "forte-disminution"
};

export const demandStatus = {
    "F": i18n.t('constants.demand_status.F'),
    "P": i18n.t('constants.demand_status.P'),
    "M": i18n.t('constants.demand_status.M'),
    "I": i18n.t('constants.demand_status.I'),
    "R": i18n.t('constants.demand_status.R'),
    "C": i18n.t('constants.demand_status.C'),
    "O": i18n.t('constants.demand_status.O'),
    "D": i18n.t('constants.demand_status.D'),
    "X": i18n.t('constants.demand_status.X')
};

export const resultStatus = {
    "F": i18n.t('constants.result_status.F'),
    "P": i18n.t('constants.result_status.P'),
    "U": i18n.t('constants.result_status.U'),
    "I": i18n.t('constants.result_status.I'),
    "R": i18n.t('constants.result_status.R'),
    "C": i18n.t('constants.result_status.C'),
    "D": i18n.t('constants.result_status.D'),
    "X": i18n.t('constants.result_status.X'),
    "SECURE": i18n.t('constants.result_status.SECURE'),
    "IN_PROGRESS": i18n.t('constants.result_status.IN_PROGRESS'),
    "REJECT": i18n.t('constants.result_status.reject')

};

export const ERRORS = {
    "ins": i18n.t('errors.ins'),
    "invalidFutureDate": i18n.t('errors.invalidFutureDate'),
    "invalidDate": i18n.t('errors.invalidDate'),
    "dateLessError": i18n.t('errors.dateLessError'),
    "invalidMinDate": i18n.t('errors.invalidMinDate'),
    "numberRequired": i18n.t("errors.numberRequired"),
    "moreThanOneMonth": i18n.t('errors.moreThanOneMonth')
};

// Géré dans la partie Paramètre
// export const demandValidationLabels = {
//     "V": "Validé par le biologiste responsable",
//     "B": "interprété par le biologiste responsable",
//     "A": "Validé par le biologiste responsable"
// };